<app-header></app-header> 

<!-- Title -->
<div class="section-lg bg-image parallax" style="background-image: url('assets/images/backgrounds/title-bg-1.jpg');">
  <div class="bg-dark-07">
    <div class="container">
      <div class="row g-4">
        <div class="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2 text-center">
          <h1 class="fw-black m-0 display-4">Our Services</h1>
          <h2 class="fw-thin uppercase">CREATIVE DIGITAL AGENCY SINCE 2004</h2>
        </div>
      </div><!-- end row -->
    </div><!-- end container -->
  </div>
</div>
<!-- end Title -->

<!-- Services section -->
<div class="section">
    <div class="container">
        <div class="row align-items-center mrt-50">
            <div class="col-md-4 main-service-box text-center radius-50" *ngFor="let service of services">
                <i class="bi" [ngClass]="service.icon"></i>
                <h4>{{service.title}}</h4>
                <p>{{service.desc}}</p>
            </div>
        </div>
    </div><!-- end container -->
</div>
<!-- end Services section -->

<!-- Testimonial section -->
<div class="section pd-t-0">
  <div class="container">
    <owl-carousel-o [options]="testimonialOptions" class="owl-btn-center-lr mrt-80 testimonial testimonial-three pd-0">
        <ng-template carouselSlide *ngFor="let tes of testimonials">
            <!-- Testimonial box -->
            <div class="testimonial-item">
                <div class="testimonial-content">
                    <div class="testimonial-content-in radius-50">
                        <div class="img">
                            <img class="img-responsive border-radius-100" src="assets/images/team/{{tes.image}}" alt="client-img">
                        </div>
                        <h5>{{tes.name}}</h5>
                        <h6>{{tes.position}}</h6>
                        <p>{{tes.desc}}</p>
                    </div>
                </div>
            </div>
        </ng-template>
    </owl-carousel-o>
    <!-- end owl-carousel -->
  </div><!-- end container -->
</div>
<!-- end Testimonial section -->

<!-- Parallax section -->
<div class="section-xl bg-image parallax" style="background-image: url(assets/images/backgrounds/main-bg-2.jpg);">
  <div class="bg-dark-01">
    <div class="container text-center">
      <div class="row g-4">
        <div class="col-12 col-sm-10 offset-sm-1 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
          <h2 class="display-4 fw-black">Creating ideas and building brands that truly matter to people.</h2>
          <a class="button button-lg button-rounded button-gradient-1 mt-4" routerLink="/contact">Call Us</a>
        </div>
      </div><!-- end row -->
    </div><!-- end container -->
  </div>
</div>
<!-- end Parallax section -->

<!-- Pricing section -->
<section class="section">
  <div class="container">
    <div class="row">
      <div class="col-md-12 heading-style-one text-center">
        <h5 class="green-color uppercase">Our Pricing Plans</h5>
        <h2><span class="fw-black">Simple pricing. No hidden costs. <br>Plans start at $0.</span></h2>
      </div>
    </div>
    <div class="row mrt-50">
      <div class="col-md-4 pricing-table" *ngFor="let plan of pricingPlans">
        <div class="pricing-box">
          <i [class]="plan.icon"></i>
          <h4>{{plan.name}}</h4>
          <h2><span>{{plan.price}}</span></h2>
          <ul>
            <li *ngFor="let feature of plan.features">
              <i [class]="feature.available ? 'bi bi-check2' : 'mdi mdi-close'"></i>
              <span>{{feature.value}}</span> {{feature.text}}
            </li>
          </ul>
          <div class="pricing-box-bottom">
            <a routerLink="/pricing-table" class="button button-lg btn-candy button-rounded">
              Get Started
            </a>
          </div>

        </div>

      </div>
    </div>
  </div>
</section>
<!-- end Pricing section -->

<footer class="footer footer-three">
  <div class="footer-main">
    <div class="container">
      <div class="row">
        <!-- ABOUT -->
        <div class="col-sm-6 col-md-3">
          <div class="widget widget-links">
            <h5 class="widget-title">About Us</h5>
            <div class="footer-about">
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                In at purus varius odio tempus cursus. vitae, commodo dui.
              </p>
              <ul class="social-media">
                <li *ngFor="let social of socialLinks">
                  <a [href]="social.url" class="bi" [ngClass]="social.icon"></a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- QUICK LINKS -->
        <div class="col-sm-6 col-md-2">
          <div class="widget widget-links">
            <h5 class="widget-title">Quick Links</h5>
            <ul>
              <li *ngFor="let link of quickLinks">
                <a [href]="link.url">{{link.name}}</a>
              </li>
            </ul>
          </div>
        </div>
        <!-- RECENT POSTS -->
        <div class="col-sm-6 col-md-4">
          <div class="widget widget-links">
            <h5 class="widget-title">Recent Post</h5>
            <div class="row post-sm-content" *ngFor="let post of recentPosts; let i=index" [class.mrt-20]="i > 0">
              <div class="col-md-3 col-sm-3 col-xs-3">
                <img class="img-overlay border-radius-100" [src]="post.image" alt="post">
              </div>
              <div class="col-md-9 col-sm-9 col-xs-9">
                <h6>{{post.title}}</h6>
                <p>{{post.desc}}</p>
              </div>
            </div>
          </div>
        </div>
        <!-- CONTACT -->
        <div class="col-sm-6 col-md-3">
          <div class="widget widget-text">
            <h5 class="widget-title">Contact Us</h5>
            <ul class="footer-contact">
              <li>
                <i class="bi bi-pin-fill"></i>
                <p>Schönhauser Allee 167c 10435 Berlin Germany</p>
              </li>
              <li>
                <i class="bi bi-envelope"></i>
                <p>
                  <a href="mailto:yoursite@gmail.com">
                    yoursite&#64;gmail.com
                  </a>
                </p>
              </li>
              <li>
                <i class="bi bi-phone-fill"></i>
                <p>+49 30 47373795</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>


  <!-- COPYRIGHT -->
  <div class="footer-copyright">

    <div class="container">

      <div class="row d-flex justify-content-center">
        <div class="col-md-2">

          <div class="logo-footer">
            <a routerLink="/">
              <img class="img-responsive" src="assets/images/logo-footer.png" alt="footer-logo">
            </a>
          </div>

        </div>
      </div>


      <div class="row">
        <div class="col-md-12">

          <div class="copy-right"> © Copyright 2026 Chaos. Designed By <a href="https://themeforest.net/user/designsninja/portfolio" target="_blank">
              DesignsNinja
            </a>
          </div>

        </div>
      </div>

    </div>

  </div>

</footer>